import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserRoleEnum } from '../../enums/user-role-enum';

import { AuthService } from '../../services/auth.service';
import { ProjectFilterService } from '../../services/project-filter.service';
import { UserService } from '../../services/user.service';

import { MenuItemsComponent } from '../menu-items/menu-items.component';

import { User } from '../../models/user.model';
import { LastAccessedProject } from '../../models/last-accessed-project.model';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProjectAndAdminInfo } from '../../models/project-and-admin-info.model';
import { ProjectAutoFetchService } from '../../services/project-auto-fetch.service';

declare var $: any;

@Component({
  selector: 'app-master-admin-menu',
  standalone: true,
  imports: [RouterModule, CommonModule, MenuItemsComponent, FormsModule],
  templateUrl: './master-admin-menu.component.html',
  styleUrl: './master-admin-menu.component.css',
})
export class MasterAdminMenuComponent implements OnInit {
  //authUser = localStorage.getItem('FLOCurrentUser');
  loggedUser: User = new User();
  role: any;
  userRole = UserRoleEnum;
  showProjectRealtedMenus: Boolean = false;
  selectedProjectInfo: any = {};
  lastAccessedProjects: Array<LastAccessedProject> =
    new Array<LastAccessedProject>();
  projectsToShowInUI: Array<LastAccessedProject> =
    new Array<LastAccessedProject>();
  activeProjects: Array<ProjectAndAdminInfo> = new Array<ProjectAndAdminInfo>();
  projectsToShowInAutoComplete: Array<ProjectAndAdminInfo> =
    new Array<ProjectAndAdminInfo>();

  searchText: string = ''; // For name filtering
  showAutoComplete: boolean = false;

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    private projFilterService: ProjectFilterService,
    private projectAutoFetchService: ProjectAutoFetchService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    this.role = this.loggedUser.role;
    this.jQueryEvents();

    if (this.loggedUser.project_id) {
      this.showProjectRealtedMenus = true;
      this.selectedProjectInfo = {
        project_id: this.loggedUser.project_id,
        name: this.loggedUser.project_name,
      };
      this.geLastAccessed10Projets(this.selectedProjectInfo.project_id);
    } else {
      this.geLastAccessed10Projets('');
    }

    // observe the user selcted project information
    this.projFilterService.getFilter().subscribe((projectInfo: any) => {
      this.showProjectRealtedMenus = true;

      this.selectedProjectInfo = projectInfo.ProjectInfo;
      this.geLastAccessed10Projets(this.selectedProjectInfo.project_id);
    });

    // observe whether any projects are added or edited
    this.projectAutoFetchService.getProject().subscribe((projectInfo: any) => {
      this.getActiveProjects();
    });

    this.getActiveProjects();
  }

  jQueryEvents(): void {
    $('div.jq-site-wrap').on('click', 'div.jq-menu-icon-wrap', function () {
      if ($('div.jq-site-wrap aside').hasClass('sidebar_large')) {
        $('div.jq-site-wrap aside').removeClass('sidebar_large');
        $('div.jq-site-wrap main').addClass('main-content_lg');
      } else {
        $('div.jq-site-wrap aside').addClass('sidebar_large');
        $('div.jq-site-wrap main').removeClass('main-content_lg');
      }
    });
  }

  geLastAccessed10Projets(project_id: String): void {
    this.userService.geLastAccessed10Projets().subscribe(
      (response: any) => {
        this.lastAccessedProjects = response.data;
        this.projectsToShowInUI = this.lastAccessedProjects.filter(
          (x) => x.Project.id !== project_id
        );
      },
      (error: any) => {
        console.error(error.error.message);
      }
    );
  }

  getActiveProjects(): void {
    this.userService.getActiveProjects().subscribe(
      (response: any) => {
        this.activeProjects = response.data;
      },
      (error: any) => {
        console.error(error.error.message);
      }
    );
  }

  onSearch() {
    /*this.projectsToShowInUI = this.filterByProjectName(
      this.searchText,
      this.selectedProjectInfo.project_id
    );*/

    this.projectsToShowInAutoComplete = this.filterActiveProjectsByName(
      this.searchText
    );
    this.showAutoComplete =
      this.projectsToShowInAutoComplete.length !== 0 &&
      this.searchText.length > 2;
  }

  filterByProjectName(
    searchText: String,
    id: String | null = null
  ): Array<LastAccessedProject> {
    return this.lastAccessedProjects.filter((item) => {
      const { name, id: projectId } = item.Project;

      // Check if name matches the search text
      const matchesName = name.toLowerCase().includes(searchText.toLowerCase());

      // Check if ID not matches (if provided)
      const matchesId = id ? projectId !== id : true;

      // Return true only if both conditions are met
      return matchesName && matchesId;
    });
  }

  switchProject(project_id: any, name: any): void {
    this.spinner.show();
    this.setProjectBehaviorSubject(project_id, name);
    this.userService.addRecentProjectLogs({ project_id }).subscribe(
      (response: any) => {
        //this.toastr.success(response.message.Text, `Project List`);
        this.lastAccessedProjects = response.data;
        this.projectsToShowInUI = this.lastAccessedProjects.filter(
          (x) => x.Project.id !== project_id
        );
        this.searchText = '';
        this.selectedProjectInfo = {
          project_id: project_id,
          name: name,
        };
        this.showAutoComplete = false;
        this.showProjectRealtedMenus = true;
        this.reloadHomePage();
        this.spinner.hide();
      },
      (error: any) => {
        this.toastr.error(error.error.message.Text, `Project List`);
        this.spinner.hide();
        console.error(error.error.message);
      }
    );
  }

  setProjectBehaviorSubject(id: any, name: any) {
    let loggedUser = this.authService.CurrentUserValue;
    loggedUser.project_id = id;
    loggedUser.project_name = name;
    this.authService.setLoggedUserInfoToLocalStorage(loggedUser);
    //this.projFilterService.setFilter({ project_id: id, name: name });
  }

  reloadHomePage() {
    this.router
      .navigateByUrl('/help-and-support', { skipLocationChange: true })
      .then(() => {
        setTimeout(() => this.router.navigate(['/home']));
      });
  }

  filterActiveProjectsByName(searchText: string): Array<ProjectAndAdminInfo> {
    return this.activeProjects.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  hideAutocomplete(): void {
    this.showAutoComplete = false;
    this.searchText = '';
  }
}
